import { toPairs, map } from 'lodash-es';
import Image from 'components/Image';

const pictureQueries = {
  '479px': 7,
  '767px': 5,
  '1024px': 3,
  '1366px': 2,
  '1920px': 1,
  '2560px': 0,
};

const Picture = ({ src, ...rest }) => (
  <picture>
    {map(toPairs(pictureQueries), ([resolution, pathIndex], key) => {
      let img;
      try {
        img = require(`../../public/images/${pathIndex}/${src}`);
      } catch (error) {
        return null;
      }

      return (
        <source key={key} media={`(max-width: ${resolution})`} srcSet={img} />
      );
    })}
    <Image {...rest} src={`0/${src}`} />
  </picture>
);

export default Picture;
